import * as ToggleGroup from "@radix-ui/react-toggle-group";

export default function ButtonSet({
    value,
    onChange,
    name,
    options = [],
    allowDeselect = false, // if true, user can unselect all and sent empty value.
    type = "button",
}) {
    return (
        <ToggleGroup.Root
            type="single"
            value={value}
            name={name}
            onValueChange={(val) => {
                if (val || allowDeselect) {
                    onChange(name, val || "");
                }
            }}
            className="inline-flex flex-wrap space-x-2 gap-2"
        >
            {options.map((opt) => (
                <ToggleGroup.Item
                    value={opt.value}
                    className="px-4 py-2 !m-0 hover:bg-gray-100 transition-colors duration-200 ease-in-out border border-gray-300 rounded-lg data-[state=on]:bg-blue-500 data-[state=on]:border-blue-500 data-[state=on]:text-white"
                >
                    {opt.label}
                </ToggleGroup.Item>
            ))}
        </ToggleGroup.Root>
    );
}
